// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {contractUpdate} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import {changeWorkSubmitting} from "../../../Work/workSubmittingSlice";
import {changeContractStats} from "../../WorkStats/contractStatsSlice";
import {changeContractStatsControls} from "../../WorkStats/contractStatsControlsSlice";
import {changeCrudSnackbar} from "../../../CommonComponents/crudSnackbarSlice";


// main function
export default function ApproveContract({ onMenuClose, rowContractData, selectorContractList }) {

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleApprove = () => {
        onMenuClose();
        dispatchData(changeWorkSubmitting({submitting: true }));
        console.log("currentUserName: ", currentUserName);
        contractUpdate(contractArray, [], [],'Update Status',
            '2032', null, currentUserName, true)
            .then(() => {
                dispatchData(changeContractStats({refreshStats: true}));
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true, }));
                dispatchData(changeWorkSubmitting({submitting: false }));
            })
            .catch(err => {
                err.response.json().then(res => {
                    console.log(res);
                    // dispatchData(changeWorkQueue({ workQueueFinalize: false}));
                    setSubmitting(false);
                    dispatchData(changeWorkSubmitting({submitting: false}));
                    dispatchData(changeWorkQueue({ actionMenuAction: null, workQueueCSGridRefresh: true}));
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Approving failed"}));
                    // errorNotification(
                    //     "There was an issue",
                    //     `${res.message} [${res.status}] [${res.error}]`
                    // )
                });
            })
            .finally(()=> {
                dispatchData(changeWorkQueue({actionMenuAction: null }));
                dispatchData(changeContractStatsControls({gridRefresh: true}));
            });
    };


    return (

        <Box>
            {(rowContractData.contractLevel === "Series" ||
                    rowContractData.contractLevel === "Season" ||
                    rowContractData.contractLevel === "Residuals" ||
                    rowContractData.contractLevel === "Participations" ||
                    rowContractData.contractLevel === "Royalties" ||
                    (rowContractData.contractLevel === "Property"  && rowContractData.groupedStatus === "Finalized") ||
                    (rowContractData.contractLevel === "Labor Group" && rowContractData.groupedStatus === "Finalized")) &&
                <MenuItem onClick={handleApprove}>
                    <ListItemIcon>
                        <ThumbUpIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Approve</ListItemText>
                </MenuItem>}
        </Box>

    )

}
